// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1JTBX","name":"ConsentHeader_name__1b7sU","birthday":"ConsentHeader_birthday__2Kyp2","skeleton":"ConsentHeader_skeleton__9rpum"};